import React, { useState, useEffect } from 'react';
import ContainerDimensions from 'react-container-dimensions';
import styled from 'styled-components';
import { Toy } from './Toy';
import { toysState, remainingToysCountState, gameProgressState } from '../../state';
import { useRecoilState, useRecoilValue } from 'recoil';

const COUNTDOWN_SECONDS = 15;

const StyledGameBoard = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content:center;
  width: 100%;
  height: 100%;
  cursor:url(img/handcursor.ico), grab;
  ${({ gameProgress }) => gameProgress !== 'main' && 'opacity: 0.3;'}
  @media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){
    cursor:url(img/handcursor.cur), auto;
  }
`;

const ActionButton = styled.button`
  background-color: ${({ active }) => active ? '#8ec44a':'#c6c6c6'};
  color: #ffffff;
  font-size:24px;
  border: 0px;
  border-radius: 50px;
  padding: 18px 36px;
  box-shadow: 0 4px 6px 0 rgba(0,0,0,0.2), 0 8px 10px 0 rgba(0,0,0,0.19);
`;

const RemainingToysCountText = styled.div`
${({ remainingToysCount }) => remainingToysCount<=0 && 'display:none;'}
`;

const Footer = styled.div`
  display: flex;
  margin-top: 12px;
`;

const FooterContent = styled.div`
  text-align: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  ${({ gameProgress }) => gameProgress!=='main' && 'display:none;'}
`

const Logo = styled.img`
  height: 60px;
  padding: 20px;
  right: 0;
  position: absolute;
  ${({ gameProgress }) => gameProgress !== 'main' && 'opacity: 0.3;'}
`;

const Board = () => {
  return (
    <ContainerDimensions>
      <GameBoard />
    </ContainerDimensions>
  )
};

const GameBoard = ({
  width,
  height,
}) => {
  const [gameProgress, setGameProgress] = useRecoilState(gameProgressState);
  const [toys, setToys] = useRecoilState(toysState);
  const remainingToysCount = useRecoilValue(remainingToysCountState);
  const [remainingSeconds, setRemainingSeconds] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (gameProgress !== 'main') {
      if (remainingSeconds !== COUNTDOWN_SECONDS) {
        setRemainingSeconds(COUNTDOWN_SECONDS)
      }
      return
    }
    if (remainingSeconds <= 0) {
      return
    }
    setTimeout(() => {
      if (gameProgress !== 'main') {
        return
      }
      setRemainingSeconds((second) => second > 0 ? second - 1 : second)
    }, 1000)
  }, [gameProgress, remainingSeconds]);

  const handleToySelect = (id) => {
    if (gameProgress !== 'main') {
      return;
    }
    setToys(toys.map((toy) => {
      if (toy.id !== id) {
        return toy;
      }
      if(remainingToysCount === 0 && toy.selected === false){
          return toy;
      }
      return {
        ...toy,
        selected: !toy.selected
      };
    }));
  }

  const gameEnded = remainingToysCount === 0
  return (
    <>
      <StyledGameBoard gameProgress={gameProgress}>
        {
          toys.map(({
            id,
            name,
            img,
            selected
          }) => {
            return (
              <Toy
                isSelected={selected}
                key={id}
                id={id}
                name={name}
                img={img}
                onClick={handleToySelect}
              />
            );
          })
        }
      </StyledGameBoard>
      <Footer>
        <FooterContent  gameProgress={gameProgress}>
          <div>
          <ActionButton onClick={() => {gameEnded && setGameProgress('result')}} active={gameEnded}>
            <ActionButtonLabel remainingToysCount={remainingToysCount} remainingSeconds={remainingSeconds} />
          </ActionButton>
          <RemainingToysCountText remainingToysCount={remainingToysCount}>
          <p>再選 {remainingToysCount} 個</p>
          </RemainingToysCountText>
          </div>
        </FooterContent>
      </Footer>
      <div><Logo src="img/hrtlogo.png" className="backgound-logo" alt='logo'  gameProgress={gameProgress} /></div>
    </>
  );
}

const ActionButtonLabel = ({
  remainingToysCount,
  remainingSeconds
}) => {
  if (remainingToysCount === 0) {
    return (
      <>查看結果</>
    )
  } else if(remainingSeconds === 0){
    return (
      <>快！時間快到了！</>
    )
  }
  return (
    <>倒數 <span className="count-number">{remainingSeconds}</span> 秒</>
  )
}

export {
  Board
}
